import { Td } from '../../../../../components/PdfExportV2/Td/Td.tsx';
import { Tr } from '../../../../../components/PdfExportV2/Tr/Tr.tsx';
import { Text } from '../../../../../components/pdf-export/Text/Text.tsx';
import { BORDER } from '../../consts.ts';
import { textStyleOverrides } from '../consts.ts';
import { makeColSpan } from '../utils/makeColSpan.ts';

type Props = {
  data: {
    label: string;
    value: (string | null)[];
  };
};

export function ExportManufacturedCostApproachTableSectionRow(props: Props) {
  const {
    data: { label, value },
  } = props;

  return (
    <Tr>
      <Td
        style={{
          width: makeColSpan(0, 1),
          borderLeft: BORDER,
        }}
      >
        <Text variant="body1" {...textStyleOverrides}>
          {label}
        </Text>
      </Td>
      <Td
        style={{
          width: makeColSpan(1, 3),
        }}
      >
        <Text variant="body1" {...textStyleOverrides}>
          {value[0] ?? ''}
        </Text>
      </Td>
      <Td
        style={{
          width: makeColSpan(4, 3),
        }}
      >
        <Text variant="body1" {...textStyleOverrides}>
          {value[1] ?? ''}
        </Text>
      </Td>
      <Td
        style={{
          width: makeColSpan(7, 1),
          textAlign: 'right',
        }}
      >
        <Text variant="body1" {...textStyleOverrides}>
          {value[2] ?? ''}
        </Text>
      </Td>
    </Tr>
  );
}
